import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useCallback, useState, useRef, useEffect, useContext } from 'react';
import DealerAd from '../..';
import { useWixDealerListener } from '../../DealerAdIframe';
import ddt from '@wix/da-ddt';
import cn from 'classnames';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton/IconButton';
import Close from '@wix/da-ds/pkg/Icons/24x24/Close/Close';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import axios from 'axios';
import { yieldToMainAsync } from '@wix/da-hooks/pkg/yieldToMain';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import isEmpty from 'lodash/isEmpty';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import s from './Modal.scss';
const ModalAdUnit = ({ realEstateId })=>{
    const [isVisible, setIsVisible] = useState(false);
    const dialogRef = useRef(null);
    const [passedOffer, setPassedOffer] = useState(undefined);
    const isMobile = useContext(MobileContext);
    const isMounted = useIsMounted();
    const { biClientIdSigned, biClientId, useridUuid } = useContext(SessionContext);
    const closeHandler = useCallback(async ()=>{
        await yieldToMainAsync();
        dialogRef && dialogRef.current && dialogRef.current.close();
        await yieldToMainAsync();
        const userId = useridUuid === '' ? biClientId : useridUuid;
        const params = {
            realEstateId,
            offerId: passedOffer.offerGuid,
            userId: userId,
            targetAccountId: userId,
            loggedInAccountId: userId
        };
        if (passedOffer) {
            // https://bo.wix.com/wix-docs/rest/internal-tools/dealer-offer-events/report-event
            axios.create().post(`https://www.wix.com/_api/dealer-offer-events-service/proxy/v1/dealer-offer-events/${passedOffer === null || passedOffer === void 0 ? void 0 : passedOffer.offerGuid}`, {
                deviantArtUserId: biClientIdSigned,
                event: _object_spread({
                    type: 'CLOSE'
                }, params)
            }, {
                headers: {}
            }).catch((e)=>{});
            // https://bo.wix.com/wix-docs/rest/internal-tools/dealer-offer-events/report-event
            axios.create().post(`https://www.wix.com/_api/dealer-offer-events-service/proxy/v1/dealer-offer-events/${passedOffer === null || passedOffer === void 0 ? void 0 : passedOffer.offerGuid}`, {
                deviantArtUserId: biClientIdSigned,
                event: _object_spread({
                    type: 'SHOW_LATER'
                }, params)
            }, {
                headers: {}
            }).catch((e)=>{});
        }
    }, [
        biClientId,
        biClientIdSigned,
        passedOffer,
        realEstateId,
        useridUuid
    ]);
    useEffect(()=>{
        const dialog = dialogRef.current;
        let showModal = true;
        // Show the dialog
        if (dialog && isVisible && passedOffer) {
            let width = passedOffer.asset.creative.modal.desktop.width;
            let height = passedOffer.asset.creative.modal.desktop.height;
            // Mobile either is given dimensions or we scale down to 300x400
            if (isMobile) {
                var _passedOffer_asset_creative_modal_mobile_width;
                width = (_passedOffer_asset_creative_modal_mobile_width = passedOffer.asset.creative.modal.mobile.width) !== null && _passedOffer_asset_creative_modal_mobile_width !== void 0 ? _passedOffer_asset_creative_modal_mobile_width : '300';
                var _passedOffer_asset_creative_modal_mobile_height;
                height = (_passedOffer_asset_creative_modal_mobile_height = passedOffer.asset.creative.modal.mobile.height) !== null && _passedOffer_asset_creative_modal_mobile_height !== void 0 ? _passedOffer_asset_creative_modal_mobile_height : '400';
            }
            const calcWidth = `${width}px`;
            const calcHeight = `${height}px`;
            dialog.style.minWidth = calcWidth;
            dialog.style.width = calcWidth;
            dialog.style.minHeight = calcHeight;
            dialog.style.height = calcHeight;
            // Nothing to display
            if (isEmpty(passedOffer.asset.creative.modal.desktop) || isMobile && isEmpty(passedOffer.asset.creative.modal.mobile.iframeContent)) {
                showModal = false;
            }
            showModal && dialog.showModal();
        }
        // Handle outside clicks
        const clickOutside = (event)=>{
            if (dialog) {
                const rect = dialog.getBoundingClientRect();
                if (event.clientY < rect.top || event.clientY > rect.bottom) {
                    return closeHandler();
                }
                if (event.clientX < rect.left || event.clientX > rect.right) {
                    return closeHandler();
                }
            }
        };
        if (dialog) {
            dialog.addEventListener('click', clickOutside);
        }
        return ()=>{
            if (dialog) {
                dialog.removeEventListener('click', clickOutside);
            }
        };
    }, [
        isVisible,
        passedOffer,
        isMobile,
        closeHandler
    ]);
    const handler = useCallback((data)=>{
        ddt.log('dealer', 'Got command from iframe2', data);
        switch(data.command){
            case 'show-modal':
                setPassedOffer(data.data);
                setIsVisible(true);
                break;
            default:
                break;
        }
    }, []);
    useWixDealerListener(realEstateId, handler);
    if (!isMounted) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "AdhesionAdUnit"
    }, /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], isVisible && s['visible'])
    }, /*#__PURE__*/ React.createElement("dialog", {
        className: s['dialog'],
        ref: dialogRef
    }, /*#__PURE__*/ React.createElement(DealerAd, {
        disableLazy: true,
        className: s['unit'],
        realEstateId: realEstateId,
        extraParams: process.env.NODE_ENV === 'development' ? {
            forcefixture: 'modal'
        } : {}
    }), /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.DARK
    }, /*#__PURE__*/ React.createElement(IconButton, {
        icon: Close,
        size: 'medium',
        className: s['close'],
        onClick: closeHandler
    })))));
};
ModalAdUnit.displayName = 'ModalAdUnit';
export default ModalAdUnit;
